module.exports = "<div>\n  <div ui-view=\"inst_active_power\" ng-class=\"$root.isSimpleDisplay ? 'demand-monitoring-simple-display' : 'demand-monitoring'\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/demand/monitoring/demand_monitoring.html
// module id = 713
// module chunks = 0